'use client';

import { c as _c } from "react/compiler-runtime";
import { AppearanceSelector, AppearanceSelectorOption, Button } from '@sprd/sprd-component-kit/v2';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { AppearanceImage } from '@/utility/appearanceConfig';
import { getCYODesignerPageHrefArgs } from '@/utility/urls';
import { SprdResponsiveImage, SprdResponsiveImageData } from '../ResponsiveImage/SprdResponsiveImage';
import { VolumeDiscountProductItem } from './VolumeDiscountProductCard';
type VolumeDiscountProductPreviewProps = {
  selectedCard?: VolumeDiscountProductItem;
  appearanceConfig: Record<string, AppearanceImage>;
};
export default function VolumeDiscountProductPreview(t0) {
  const $ = _c(70);
  const {
    selectedCard,
    appearanceConfig
  } = t0;
  const t = useTranslations();
  const [pickedAppearanceId, setPickedAppearanceId] = useState();
  if (!selectedCard) {
    return null;
  }
  const selectedAppearanceId = pickedAppearanceId ?? selectedCard.image.appearanceId;
  let T0;
  let designerUrl;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== appearanceConfig || $[1] !== selectedAppearanceId || $[2] !== selectedCard.appearanceIds || $[3] !== selectedCard.image || $[4] !== selectedCard.imageBaseUrl || $[5] !== selectedCard.isEmbroideryOnly || $[6] !== selectedCard.productTypeId || $[7] !== selectedCard.title || $[8] !== t) {
    let t10;
    if ($[20] !== appearanceConfig) {
      t10 = id => appearanceConfig[id];
      $[20] = appearanceConfig;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    const appearances = selectedCard.appearanceIds.map(t10).filter(_temp);
    const appearanceName = appearanceConfig[selectedAppearanceId]?.name;
    const t11 = appearanceName ? `${selectedCard.title}, ${appearanceName}` : selectedCard.title;
    let t12;
    if ($[22] !== selectedAppearanceId || $[23] !== selectedCard.image || $[24] !== t11) {
      t12 = {
        ...selectedCard.image,
        appearanceId: selectedAppearanceId,
        alt: t11
      };
      $[22] = selectedAppearanceId;
      $[23] = selectedCard.image;
      $[24] = t11;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    const image = t12;
    const t13 = Number(selectedCard.productTypeId);
    const t14 = Number(selectedAppearanceId);
    const t15 = selectedCard.isEmbroideryOnly ? true : undefined;
    let t16;
    if ($[26] !== t13 || $[27] !== t14 || $[28] !== t15) {
      t16 = getCYODesignerPageHrefArgs({
        productType: t13,
        appearance: t14,
        embroidery: t15
      });
      $[26] = t13;
      $[27] = t14;
      $[28] = t15;
      $[29] = t16;
    } else {
      t16 = $[29];
    }
    designerUrl = t16;
    t8 = "flex h-full w-full flex-col";
    if ($[30] !== image || $[31] !== selectedCard.imageBaseUrl) {
      t9 = <SprdResponsiveImage imageBaseUrl={selectedCard.imageBaseUrl} image={image} defaultImageHeight={500} className="my-auto h-auto object-contain! px-12!" />;
      $[30] = image;
      $[31] = selectedCard.imageBaseUrl;
      $[32] = t9;
    } else {
      t9 = $[32];
    }
    t7 = "flex items-center justify-between gap-4 p-6";
    t5 = "flex min-w-0 flex-1 flex-col gap-3";
    if ($[33] !== selectedCard.title) {
      t6 = <h3 className="font-display text-md w-fit leading-tight font-black text-balance text-black underline-offset-4">{selectedCard.title}</h3>;
      $[33] = selectedCard.title;
      $[34] = t6;
    } else {
      t6 = $[34];
    }
    t4 = "flex items-center gap-1 md:gap-3";
    T0 = AppearanceSelector;
    if ($[35] !== t) {
      t1 = t("cyoAssortmentDetailPage.selectAppearance");
      $[35] = t;
      $[36] = t1;
    } else {
      t1 = $[36];
    }
    t2 = "flex flex-wrap gap-0.5! md:gap-1!";
    let t17;
    if ($[37] !== selectedAppearanceId) {
      t17 = appearance_0 => <AppearanceSelectorOption className="relative shrink-0" key={appearance_0.id} id={appearance_0.id} colors={appearance_0.colors} name={appearance_0.name} size="s" selected={appearance_0.id === selectedAppearanceId} textureImage={appearance_0.textureImage} asChild={true}><button onClick={() => setPickedAppearanceId(appearance_0.id)} /></AppearanceSelectorOption>;
      $[37] = selectedAppearanceId;
      $[38] = t17;
    } else {
      t17 = $[38];
    }
    t3 = appearances.map(t17);
    $[0] = appearanceConfig;
    $[1] = selectedAppearanceId;
    $[2] = selectedCard.appearanceIds;
    $[3] = selectedCard.image;
    $[4] = selectedCard.imageBaseUrl;
    $[5] = selectedCard.isEmbroideryOnly;
    $[6] = selectedCard.productTypeId;
    $[7] = selectedCard.title;
    $[8] = t;
    $[9] = T0;
    $[10] = designerUrl;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[9];
    designerUrl = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[39] !== T0 || $[40] !== t1 || $[41] !== t2 || $[42] !== t3) {
    t10 = <T0 label={t1} className={t2}>{t3}</T0>;
    $[39] = T0;
    $[40] = t1;
    $[41] = t2;
    $[42] = t3;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  let t11;
  if ($[44] !== t) {
    t11 = t("volumeDiscountCalculator.seeAllColors");
    $[44] = t;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] !== designerUrl || $[47] !== t11) {
    t12 = <Link href={designerUrl} target="_blank" className="shrink-0 text-xs font-semibold whitespace-nowrap text-black">{t11}</Link>;
    $[46] = designerUrl;
    $[47] = t11;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] !== t10 || $[50] !== t12 || $[51] !== t4) {
    t13 = <div className={t4}>{t10}{t12}</div>;
    $[49] = t10;
    $[50] = t12;
    $[51] = t4;
    $[52] = t13;
  } else {
    t13 = $[52];
  }
  let t14;
  if ($[53] !== t13 || $[54] !== t5 || $[55] !== t6) {
    t14 = <div className={t5}>{t6}{t13}</div>;
    $[53] = t13;
    $[54] = t5;
    $[55] = t6;
    $[56] = t14;
  } else {
    t14 = $[56];
  }
  let t15;
  if ($[57] !== t) {
    t15 = t("volumeDiscountCalculator.cta");
    $[57] = t;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  let t16;
  if ($[59] !== designerUrl || $[60] !== t15) {
    t16 = <Button variant="primary" size="l" asChild={true}><Link href={designerUrl} target="_blank">{t15}</Link></Button>;
    $[59] = designerUrl;
    $[60] = t15;
    $[61] = t16;
  } else {
    t16 = $[61];
  }
  let t17;
  if ($[62] !== t14 || $[63] !== t16 || $[64] !== t7) {
    t17 = <div className={t7}>{t14}{t16}</div>;
    $[62] = t14;
    $[63] = t16;
    $[64] = t7;
    $[65] = t17;
  } else {
    t17 = $[65];
  }
  let t18;
  if ($[66] !== t17 || $[67] !== t8 || $[68] !== t9) {
    t18 = <div className={t8}>{t9}{t17}</div>;
    $[66] = t17;
    $[67] = t8;
    $[68] = t9;
    $[69] = t18;
  } else {
    t18 = $[69];
  }
  return t18;
}
function _temp(appearance) {
  return appearance !== undefined;
}